import { useQuery } from "@tanstack/react-query";

export function useAuth() {
  const {
    data: user,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["/api/auth/me"],
    retry: false,
  });

  // Authentication state is now working correctly

  return {
    user,
    isLoading,
    isAuthenticated: !!user && !isLoading,
  };
}
